<!-- <div class="pagetitle">
	<nav>
		<ol class="breadcrumb">
			<li class="breadcrumb-item" *ngFor="let item of breadcrumbList; let i = index"
				[class.active]="i===breadcrumbList.length-1">
				<a [routerLink]="item.path" *ngIf="i!==breadcrumbList.length-1">{{ item.name }}</a>
				<span *ngIf="i===breadcrumbList.length-1"><b>{{ item.name }}</b></span>
			</li>
		</ol>
	</nav>
</div> -->
<nav class="custom-breadcrumbs">
	<ng-container *ngFor="let item of breadcrumbList; let i = index">
		<a *ngIf="i!==breadcrumbList.length-1" [routerLink]="item.path" class="custom-breadcrumb-item">
			{{ item.name }}
		</a>
		<span *ngIf="i===breadcrumbList.length-1" class="custom-breadcrumb-item active-breadcrumb">
			{{ item.name }}
		</span>
	</ng-container>
</nav>